export interface FeatureFlags {
  enableAuth: boolean;
  enableRegistration: boolean;
  enableVolunteerSearch: boolean;
  enableOrganizationPortal: boolean;
  enableSchoolPortal: boolean;
  enableHowItWorks: boolean;
}

// Environment-specific configurations
const environmentConfigs = {
  development: {
    enableAuth: true,
    enableRegistration: true,
    enableVolunteerSearch: true,
    enableOrganizationPortal: true,
    enableSchoolPortal: true,
    enableHowItWorks: false,
  },
  staging: {
    enableAuth: true,
    enableRegistration: true,
    enableVolunteerSearch: true,
    enableOrganizationPortal: true,
    enableSchoolPortal: true,
    enableHowItWorks: false,
  },
  production: {
    enableAuth: false,
    enableRegistration: false,
    enableVolunteerSearch: false,
    enableOrganizationPortal: false,
    enableSchoolPortal: false,
    enableHowItWorks: false,
  },
} as const;

// Load feature flags from environment variables if available
export const loadFeatureFlags = (): FeatureFlags => {
  // Get current environment
  const env = import.meta.env.MODE || 'production';
  console.log(`Loading feature flags for environment: ${env}`);

  // Get environment-specific defaults
  const envDefaults = environmentConfigs[env as keyof typeof environmentConfigs] || environmentConfigs.production;

  // Override with environment variables if they exist
  return {
    enableAuth: import.meta.env.VITE_ENABLE_AUTH ? import.meta.env.VITE_ENABLE_AUTH === 'true' : envDefaults.enableAuth,
    enableRegistration: import.meta.env.VITE_ENABLE_REGISTRATION ? import.meta.env.VITE_ENABLE_REGISTRATION === 'true' : envDefaults.enableRegistration,
    enableVolunteerSearch: import.meta.env.VITE_ENABLE_VOLUNTEER_SEARCH ? import.meta.env.VITE_ENABLE_VOLUNTEER_SEARCH === 'true' : envDefaults.enableVolunteerSearch,
    enableOrganizationPortal: import.meta.env.VITE_ENABLE_ORGANIZATION_PORTAL ? import.meta.env.VITE_ENABLE_ORGANIZATION_PORTAL === 'true' : envDefaults.enableOrganizationPortal,
    enableSchoolPortal: import.meta.env.VITE_ENABLE_SCHOOL_PORTAL ? import.meta.env.VITE_ENABLE_SCHOOL_PORTAL === 'true' : envDefaults.enableSchoolPortal,
    enableHowItWorks: import.meta.env.VITE_ENABLE_HOW_IT_WORKS ? import.meta.env.VITE_ENABLE_HOW_IT_WORKS === 'true' : envDefaults.enableHowItWorks,
  };
};

// Cache the feature flags
let cachedFlags: FeatureFlags | null = null;

export const getFeatureFlags = (): FeatureFlags => {
  if (!cachedFlags) {
    cachedFlags = loadFeatureFlags();
  }
  return cachedFlags;
}; 